import { toast } from 'react-toastify'
import type { Response } from '../hooks/use-fetch'

interface UseApiCallOptions {
  showErrorToast?: boolean
  onSuccess?: () => void
  onError?: (errors: string[]) => void
}

export async function handleApiResponse<T> (
  apiCall: Promise<Response<T>>,
  options: UseApiCallOptions = {}
): Promise<T | null> {
  const { showErrorToast, onSuccess, onError } = options

  const { success, errors, response: data } = await apiCall

  if (success) {
    onSuccess?.()
    return data
  } else {
    if (showErrorToast ?? true) {
      for (const error of errors) toast.error(error)
    }
    onError?.(errors)
    return null
  }
}
